import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import ProductGrid from '../components/ProductGrid';
import FlashNews from '../components/FlashNews';
import { useCart } from '../contexts/CartContext';
import { productService } from '../services';
import type { Product } from '../types/Product';

const Home: React.FC = () => {
  const [featuredProducts, setFeaturedProducts] = useState<Product[]>([]);
  const [newArrivals, setNewArrivals] = useState<Product[]>([]);
  const [specialties, setSpecialties] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { addToCart } = useCart();

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setIsLoading(true);
        
        // Load featured products
        const featuredResponse = await productService.getFeaturedProducts();
        if (featuredResponse.success) {
          setFeaturedProducts(featuredResponse.data.slice(0, 4));
        }

        // Load new arrivals
        const newArrivalsResponse = await productService.getNewArrivals();
        if (newArrivalsResponse.success) {
          setNewArrivals(newArrivalsResponse.data.slice(0, 4));
        }

        // Load specialty products (gift boxes)
        const specialtiesResponse = await productService.getProductsByCategory('gift-boxes', { limit: 4 });
        if (specialtiesResponse.success) {
          setSpecialties(specialtiesResponse.data.data);
        }
      } catch {
        console.error('Error occurred');
      } finally {
        setIsLoading(false);
      }
    };

    loadProducts();
  }, []);

  const handleAddToCart = (product: Product) => {
    addToCart(product);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <FlashNews />
      <Hero />
      <ProductGrid 
        title="Featured Products" 
        products={featuredProducts} 
        onAddToCart={handleAddToCart}
      />
      <ProductGrid 
        title="New Arrivals" 
        products={newArrivals} 
        onAddToCart={handleAddToCart}
      />
      <ProductGrid 
        title="Demo Crackers Specialties" 
        products={specialties} 
        onAddToCart={handleAddToCart}
      />
    </div>
  );
};

export default Home;